<!-- ProtectedRoute.svelte-->
<script>
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Constantes from "./Classes/Constantes";
    import TelaLogin from "./Telas/Autenticacao/TelaLogin.svelte";
    import ArmazenaVariaveisLogin from "./Classes/ArmazenaVariaveisLogin";
    import { logado } from "./Classes/EstadoLogado";
    let logadoValor; // Variável local para armazenar o valor de logado

    // Assine as mudanças no valor de logado
    const unsubscribe = logado.subscribe((value) => {
        logadoValor = value;
    });

    onMount(() => {
        // Limpe a assinatura quando o componente for destruído para evitar vazamentos de memória
        return unsubscribe;
    });

    export let component;
    export let params;
    export let component2;
    export let params2;
</script>

{#if logadoValor}
    <svelte:component this={component} {params} />
{:else if component2}
    <svelte:component this={component2} {params2} />
{:else}
    <TelaLogin />
{/if}
